import './assets/index52.css';var vo = Object.defineProperty, _o = Object.defineProperties;
var yo = Object.getOwnPropertyDescriptors;
var w = Object.getOwnPropertySymbols;
var Z = Object.prototype.hasOwnProperty, oo = Object.prototype.propertyIsEnumerable;
var Y = (o, s, e) => s in o ? vo(o, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[s] = e, t = (o, s) => {
  for (var e in s || (s = {}))
    Z.call(s, e) && Y(o, e, s[e]);
  if (w)
    for (var e of w(s))
      oo.call(s, e) && Y(o, e, s[e]);
  return o;
}, m = (o, s) => _o(o, yo(s));
var S = (o, s) => {
  var e = {};
  for (var r in o)
    Z.call(o, r) && s.indexOf(r) < 0 && (e[r] = o[r]);
  if (o != null && w)
    for (var r of w(o))
      s.indexOf(r) < 0 && oo.call(o, r) && (e[r] = o[r]);
  return e;
};
import { jsx as d, jsxs as eo } from "react/jsx-runtime";
import { useContext as go, createContext as Go, useRef as Io, useEffect as Po, forwardRef as No } from "react";
import { ErrorMessage as Ro } from "./molecules/ErrorMessage/index.js";
import { Label as zo } from "./components/Label/index.js";
import { u as j } from "./use-uncontrolled-BT_j5D2R.js";
import { e as M, c as so } from "./get-size-Bc1Pz5yf.js";
import { c as W } from "./create-vars-resolver-Bzbn9G-G.js";
import { f as E, u as A, B as U, p as ro, h as B, e as So } from "./factory-ueRxoNOV.js";
import { g as co } from "./get-contrast-color-SC35uhiM.js";
import { g as to } from "./get-auto-contrast-value-BGSSZ1GD.js";
import { u as F } from "./use-styles-DToiHEa6.js";
import { I as Vo, a as $o, b as wo } from "./InputsGroupFieldset-Bo-BOy1U.js";
import { U as To } from "./UnstyledButton-D9OCzDhz.js";
import { c as Bo } from "./create-optional-context-CQ2ahjKQ.js";
import { I as ao } from "./Input--FNE961U.js";
import { a as no } from "./CheckIcon-DkmKiN6y.js";
import { u as Eo } from "./use-id-D2tGiO9x.js";
const lo = Go(null), Ao = lo.Provider, io = () => go(lo), [Oo, Uo] = Bo();
var uo = { card: "m_26775b0a" };
const jo = {
  withBorder: !0
}, Mo = W((o, { radius: s }) => ({
  card: {
    "--card-radius": M(s)
  }
})), J = E((o, s) => {
  const e = A("CheckboxCard", jo, o), y = e, {
    classNames: r,
    className: a,
    style: l,
    styles: n,
    unstyled: c,
    vars: u,
    checked: C,
    mod: i,
    withBorder: f,
    value: g,
    onClick: x,
    defaultChecked: v,
    onChange: p
  } = y, _ = S(y, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "checked",
    "mod",
    "withBorder",
    "value",
    "onClick",
    "defaultChecked",
    "onChange"
  ]), G = F({
    name: "CheckboxCard",
    classes: uo,
    props: e,
    className: a,
    style: l,
    classNames: r,
    styles: n,
    unstyled: c,
    vars: u,
    varsResolver: Mo,
    rootSelector: "card"
  }), h = io(), I = typeof C == "boolean" ? C : h ? h.value.includes(g || "") : void 0, [b, k] = j({
    value: I,
    defaultValue: v,
    finalValue: !1,
    onChange: p
  });
  return /* @__PURE__ */ d(Oo, { value: { checked: b }, children: /* @__PURE__ */ d(
    To,
    m(t(t({
      ref: s,
      mod: [{ "with-border": f, checked: b }, i]
    }, G("card")), _), {
      role: "checkbox",
      "aria-checked": b,
      onClick: (z) => {
        x == null || x(z), h == null || h.onChange(g || ""), k(!b);
      }
    })
  ) });
});
J.displayName = "@mantine/core/CheckboxCard";
J.classes = uo;
const Wo = {}, L = E((o, s) => {
  const x = A("CheckboxGroup", Wo, o), { value: e, defaultValue: r, onChange: a, size: l, wrapperProps: n, children: c, readOnly: u } = x, C = S(x, ["value", "defaultValue", "onChange", "size", "wrapperProps", "children", "readOnly"]), [i, f] = j({
    value: e,
    defaultValue: r,
    finalValue: [],
    onChange: a
  });
  return /* @__PURE__ */ d(Ao, { value: { value: i, onChange: (v) => {
    const p = typeof v == "string" ? v : v.currentTarget.value;
    !u && f(
      i.includes(p) ? i.filter((_) => _ !== p) : [...i, p]
    );
  }, size: l }, children: /* @__PURE__ */ d(
    ao.Wrapper,
    m(t(t({
      size: l,
      ref: s
    }, n), C), {
      labelElement: "div",
      __staticSelector: "CheckboxGroup",
      children: /* @__PURE__ */ d(Vo, { role: "group", children: c })
    })
  ) });
});
L.classes = ao.Wrapper.classes;
L.displayName = "@mantine/core/CheckboxGroup";
var po = { indicator: "m_5e5256ee", icon: "m_1b1c543a", "indicator--outline": "m_76e20374" };
const Fo = {
  icon: no
}, Jo = W(
  (o, { radius: s, color: e, size: r, iconColor: a, variant: l, autoContrast: n }) => {
    const c = ro({ color: e || o.primaryColor, theme: o }), u = c.isThemeColor && c.shade === void 0 ? `var(--mantine-color-${c.color}-outline)` : c.color;
    return {
      indicator: {
        "--checkbox-size": so(r, "checkbox-size"),
        "--checkbox-radius": s === void 0 ? void 0 : M(s),
        "--checkbox-color": l === "outline" ? u : B(e, o),
        "--checkbox-icon-color": a ? B(a, o) : to(n, o) ? co({ color: e, theme: o, autoContrast: n }) : void 0
      }
    };
  }
), Q = E((o, s) => {
  const e = A("CheckboxIndicator", Fo, o), O = e, {
    classNames: r,
    className: a,
    style: l,
    styles: n,
    unstyled: c,
    vars: u,
    icon: C,
    indeterminate: i,
    radius: f,
    color: g,
    iconColor: x,
    autoContrast: v,
    checked: p,
    mod: _,
    variant: G,
    disabled: h
  } = O, I = S(O, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "icon",
    "indeterminate",
    "radius",
    "color",
    "iconColor",
    "autoContrast",
    "checked",
    "mod",
    "variant",
    "disabled"
  ]), b = C, k = F({
    name: "CheckboxIndicator",
    classes: po,
    props: e,
    className: a,
    style: l,
    classNames: r,
    styles: n,
    unstyled: c,
    vars: u,
    varsResolver: Jo,
    rootSelector: "indicator"
  }), y = Uo(), z = typeof p == "boolean" || typeof i == "boolean" ? p || i : (y == null ? void 0 : y.checked) || !1;
  return /* @__PURE__ */ d(
    U,
    m(t(m(t({
      ref: s
    }, k("indicator", { variant: G })), {
      variant: G,
      mod: [{ checked: z, disabled: h }, _]
    }), I), {
      children: /* @__PURE__ */ d(b, t({ indeterminate: i }, k("icon")))
    })
  );
});
Q.displayName = "@mantine/core/CheckboxIndicator";
Q.classes = po;
var ho = { root: "m_bf2d988c", inner: "m_26062bec", input: "m_26063560", icon: "m_bf295423", "input--outline": "m_215c4542" };
const Lo = {
  labelPosition: "right",
  icon: no
}, Qo = W(
  (o, { radius: s, color: e, size: r, iconColor: a, variant: l, autoContrast: n }) => {
    const c = ro({ color: e || o.primaryColor, theme: o }), u = c.isThemeColor && c.shade === void 0 ? `var(--mantine-color-${c.color}-outline)` : c.color;
    return {
      root: {
        "--checkbox-size": so(r, "checkbox-size"),
        "--checkbox-radius": s === void 0 ? void 0 : M(s),
        "--checkbox-color": l === "outline" ? u : B(e, o),
        "--checkbox-icon-color": a ? B(a, o) : to(n, o) ? co({ color: e, theme: o, autoContrast: n }) : void 0
      }
    };
  }
), R = E((o, s) => {
  const e = A("Checkbox", Lo, o), K = e, {
    classNames: r,
    className: a,
    style: l,
    styles: n,
    unstyled: c,
    vars: u,
    color: C,
    label: i,
    id: f,
    size: g,
    radius: x,
    wrapperProps: v,
    checked: p,
    labelPosition: _,
    description: G,
    error: h,
    disabled: I,
    variant: b,
    indeterminate: k,
    icon: y,
    rootRef: z,
    iconColor: O,
    onChange: V,
    autoContrast: Yo,
    mod: mo
  } = K, Co = S(K, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "color",
    "label",
    "id",
    "size",
    "radius",
    "wrapperProps",
    "checked",
    "labelPosition",
    "description",
    "error",
    "disabled",
    "variant",
    "indeterminate",
    "icon",
    "rootRef",
    "iconColor",
    "onChange",
    "autoContrast",
    "mod"
  ]), P = io(), bo = g || (P == null ? void 0 : P.size), ko = y, $ = F({
    name: "Checkbox",
    props: e,
    classes: ho,
    className: a,
    style: l,
    classNames: r,
    styles: n,
    unstyled: c,
    vars: u,
    varsResolver: Qo
  }), { styleProps: fo, rest: q } = So(Co), D = Eo(f), H = P ? {
    checked: P.value.includes(q.value),
    onChange: (X) => {
      P.onChange(X), V == null || V(X);
    }
  } : {}, xo = Io(null), N = s || xo;
  return Po(() => {
    N && "current" in N && N.current && (N.current.indeterminate = k || !1);
  }, [k, N]), /* @__PURE__ */ d(
    $o,
    m(t(t(m(t({}, $("root")), {
      __staticSelector: "Checkbox",
      __stylesApiProps: e,
      id: D,
      size: bo,
      labelPosition: _,
      label: i,
      description: G,
      error: h,
      disabled: I,
      classNames: r,
      styles: n,
      unstyled: c,
      "data-checked": H.checked || p || void 0,
      variant: b,
      ref: z,
      mod: mo
    }), fo), v), {
      children: /* @__PURE__ */ eo(U, m(t({}, $("inner")), { mod: { "data-label-position": _ }, children: [
        /* @__PURE__ */ d(
          U,
          m(t(t(m(t({
            component: "input",
            id: D,
            ref: N,
            checked: p,
            disabled: I,
            mod: { error: !!h, indeterminate: k }
          }, $("input", { focusable: !0, variant: b })), {
            onChange: V
          }), q), H), {
            type: "checkbox"
          })
        ),
        /* @__PURE__ */ d(ko, t({ indeterminate: k }, $("icon")))
      ] }))
    })
  );
});
R.classes = t(t({}, ho), wo);
R.displayName = "@mantine/core/Checkbox";
R.Group = L;
R.Indicator = Q;
R.Card = J;
const qo = "CheckboxGroup-module__root___r0tTu", Do = "CheckboxGroup-module__container___uEOq9", Ho = "CheckboxGroup-module__label___wEJar", Ko = "CheckboxGroup-module__description___P1M4Q", T = {
  root: qo,
  container: Do,
  label: Ho,
  description: Ko
}, Xo = No(({
  label: o,
  orientation: s = "vertical",
  required: e,
  error: r,
  description: a,
  children: l,
  value: n,
  defaultValue: c,
  onChange: u
}, C) => {
  const [i, f] = j({
    value: n,
    defaultValue: c || [],
    onChange: u
  });
  return /* @__PURE__ */ eo("div", { className: T.container, children: [
    /* @__PURE__ */ d(
      R.Group,
      {
        label: typeof o == "string" ? /* @__PURE__ */ d(zo, { label: o }) : o,
        value: i,
        onChange: f,
        ref: C,
        classNames: {
          root: T.root,
          label: T.label
        },
        mod: {
          orientation: s,
          required: e
        },
        withAsterisk: e,
        children: l
      }
    ),
    a && !r && /* @__PURE__ */ d("p", { className: T.description, children: a }),
    r && /* @__PURE__ */ d(Ro, { error: r })
  ] });
});
Xo.displayName = "Checkbox.Group";
export {
  R as C,
  Xo as G
};
